// extracted by mini-css-extract-plugin
export default {"title":"yX4q1F","strikeout":"kJtPJn","container":"rthP32"};